export const ACTIVE_WORKSPACE = "active_workspace"
export const ENDPOINTS = "endpoints"
export const ORGANIZATION_METADATA = "org_metadata"
export const ACTIVE_ENDPOINT = "active_endpoint"
export const INTEGRATIONS = "integrations"
export const COMPLETED_TOUR = "tour_complete"
export const COMPLETED_HEADER_HINTS = "header_hint_complete"
export const COMPLETED_ENDPOINTS_HINTS = "endpoint_hint_complete"
